import moment from "moment"
import SettingType from "../enum/questionnaire-setings/type"
import PlayerEvent from "../../../front/js/entity/playerEvent"
import EventType from "../enum/player/event-type"
import QuestionnaireActiveButtonEntity from "./questionnaireActiveButtonEntity"
import QuestionnaireStartButtonEntity from "./questionnaireStartButtonEntity"

export default class QuestionnaireEntity {
  constructor(id, settings, isLive, startAt) {
    this.id = Number(id)
    this.events = this.generateEvents(settings)
    this.isLive = isLive
    this.startAt = startAt
    this.title = "アンケート"
    this.enabled = true
    this.active = false
    this.activeButton = new QuestionnaireActiveButtonEntity(this.title)
    this.startButton = new QuestionnaireStartButtonEntity(this.title, `${process.env.MIX_GPLUS_URL}/qnr/questionnaires/${id}`)
    this.updatedAt = new Date()
  }

  isVisible() {
    return this.enabled && this.active
  }

  trimTitle(length) {
    if (this.title.length < length) return this.title

    return `${this.title.slice(0, length)}...`
  }

  init(title, isExpired, isAnswered) {
    this.title = title
    this.enabled = !isExpired && !isAnswered
    this.updatedAt = new Date()

    // update buttons
    this.activeButton.init(this.trimTitle(5))
    this.startButton.init(this.trimTitle(16), isExpired, isAnswered)
  }

  show() {
    if (!this.enabled) return

    this.active = true
    this.updatedAt = new Date()

    // update buttons
    this.activeButton.hide()
    this.startButton.show()
  }

  close(remove) {
    if (!this.enabled) return

    this.enabled = !remove
    this.active = false
    this.updatedAt = new Date()

    // update buttons
    remove ? this.activeButton.hide() : this.activeButton.show()
    remove ? this.startButton.inactive() : this.startButton.active()
  }

  generateEvents(settings) {
    return settings.map(setting => {
      setting.type = Number(setting.type);
      switch (setting.type) {
        case SettingType.FINISHED.value:
          return this.finishedEvent(setting)
        case SettingType.STOPPED.value:
          return this.stoppedEvent(setting)
        case SettingType.FINISHED_FULLSCREEN.value:
          return this.finishedFullscreenEvent(setting)
        case SettingType.PASSED_TIME.value:
          return this.passedTimeEvent(setting)
        case SettingType.ANY.value:
          return this.anyEvent(setting)
      }
    })
  }

  finishedEvent(setting) {
    const event = new PlayerEvent(EventType.ENDED, true, setting)

    event.setCallback(() => {
      this.show()
    })

    return event
  }

  stoppedEvent(setting) {
    const event = new PlayerEvent(EventType.PAUSE, true, setting)

    event.setCallback((data, playerWrapper) => {
      const player = playerWrapper.player

      const isLiveEnded = data => {
        // safari以外、 Infinity で判定
        if (data.percent === Infinity) return false

        // safariのみ、 47721.859 で判定
        return data.duration !== 47721.859
      }

      player.getPlayed().then(played => {
        // safariではlive再生時に停止イベントが着火してしまうため、再生中のみ停止イベントが実行されるように確認
        if (!played.length) return false

        player.getFullscreen().then(value => {
          // safariではlive再生時に最大化を行うと停止イベントが着火してしまうため、確認
          if (value) return false

          player.getEnded().then(ended => {
            switch (true) {
              case this.isLive && isLiveEnded(data):
                event.enabled = false

                break
              case !this.isLive && ended:
              case data.seconds === 0:
                break
              default:
                this.show()
            }
          })
        })
      })
    })

    return event
  }

  finishedFullscreenEvent(setting) {
    const event = new PlayerEvent(EventType.FULLSCREEN_CHANGE, true, setting)

    event.setCallback(data => {
      if (!data.fullscreen) return

      this.show()
    })

    return event
  }

  passedTimeEvent(setting) {
    const event = new PlayerEvent(EventType.TIME_UPDATE, true, setting)

    const isLiveNow = data => {
      // safari以外、 Infinity で判定
      if (data.duration === Infinity) return true

      // safariのみ、 47721.859 で判定
      return data.duration === 47721.859
    }

    event.setCallback(data => {
      if (this.isLive && isLiveNow(data)) {
        const now = moment()
        const startAt = moment(this.startAt)

        // 日付を無視して比較するため 1日（86400秒）で割った余りを利用
        const diffSeconds = now.diff(startAt, "seconds") % 86400

        if (diffSeconds < setting.seconds) return
      } else {
        if (data.seconds < setting.seconds) return
      }

      event.enabled = false

      this.show()
    })

    return event
  }

  anyEvent(setting) {
    const event = new PlayerEvent(EventType.ANY, true, setting, this.id)

    event.setCallback(() => {
      this.show()
    })

    return event
  }
}
